module.exports = __webpack_public_path__ + "img/xing.b3d3869f.png";